/**
 * Permission names must match `PermissionDto.name` from `GET /api/permissions`.
 * Assign to roles via `PUT /api/roles/{roleName}/permissions` (`permissionNames`).
 */
export const APP_PERMISSIONS = {
  TodoListsRead: 'todolists.read',
  TodoListsCreate: 'todolists.create',
  TodoListsUpdate: 'todolists.update',
  TodoListsDelete: 'todolists.delete',
  TodoListsPurge: 'todolists.purge',

  TodoItemsRead: 'todoitems.read',
  TodoItemsCreate: 'todoitems.create',
  TodoItemsUpdate: 'todoitems.update',
  TodoItemsDelete: 'todoitems.delete',

  EssentialsRead: 'essentials.read',
  EssentialsCreate: 'essentials.create',
  EssentialsUpdate: 'essentials.update',
  EssentialsDelete: 'essentials.delete',

  EssentialTitlesRead: 'essentialtitles.read',
  EssentialTitlesCreate: 'essentialtitles.create',
  EssentialTitlesUpdate: 'essentialtitles.update',
  EssentialTitlesDelete: 'essentialtitles.delete',

  QuestionsRead: 'questions.read',
  QuestionsCreate: 'questions.create',
  QuestionsUpdate: 'questions.update',
  QuestionsDelete: 'questions.delete',

  AnswersRead: 'answers.read',
  AnswersCreate: 'answers.create',
  AnswersUpdate: 'answers.update',
  AnswersDelete: 'answers.delete',

  EvaluationsRead: 'evaluations.read',
  EvaluationsCreate: 'evaluations.create',
  EvaluationsUpdate: 'evaluations.update',
  EvaluationsDelete: 'evaluations.delete',
  EvaluationsPrint: 'evaluations.print',

  ReferenceDataRead: 'referencedata.read',

  /**
   * TODO : yazan korjo need to be added to backend

   */
  UsersRead: 'users.read',

  /**
   * Not assignable via role-permissions UI; used only to gate routes.
   * Administrator bypasses all permission checks in AuthService.
   */
  RolesRead: 'roles.read',
  RolesCreate: 'roles.create',
  RolesUpdate: 'roles.update',
  RolesDelete: 'roles.delete',

  /**
   * TODO : yazan korjo need to be added to backend
   */
  RolesPermissionsUpdate: 'roles.permissions.update',
} as const;

/** API role names returned by Users `manage/info-v2` (e.g. `roles` array). */
export const APP_ROLES = {
  Administrator: 'Administrator',
} as const;
